import {cleanAll, isActive, isDone, pendingMocks} from 'nock';

export class ApiMockup {
    public static isDone(): boolean {
        return isActive() && isDone();
    }

    public static pending(): string {
        return 'pending: ' + JSON.stringify(pendingMocks());
    }

    public static reset(): void {
        cleanAll();
    }
}
